/* eslint-disable ember/no-computed-properties-in-native-classes */
import { computed } from '@ember/object';

import FilterConstants from '../../../filter-constants';
import InductorLowPass from './low-pass/main';
import InductorBandPass from './band-pass/main';
import InductorHighPass from './high-pass/main';
import BaseImplementation from '../base-implementation';
import * as CommonUtils from '../../../utils/common';

export default class Inductor extends BaseImplementation {
  filter;
  preferredAlgorithm;
  name = FilterConstants.implementationType.inductor;

  @computed('filter') get instance() {
    var filter = this.filter;
    var result = null;
    var algorithm = this.algorithm;

    if (filter.name === FilterConstants.filterType.lowPass) {
      result = InductorLowPass.create({ algorithm: algorithm });
    } else if (filter.name === FilterConstants.filterType.bandPass) {
      result = InductorBandPass.create({ algorithm: algorithm });
    } else {
      result = InductorHighPass.create({ algorithm: algorithm });
    }

    return result;
  }

  @computed('name', 'preferredAlgorithm') get algorithm() {
    var filter = this.filter;
    var name = this.name;
    var preferredAlgorithm = this.preferredAlgorithm;

    if (!CommonUtils.isNullOrUndefined(preferredAlgorithm)) {
      if (name === FilterConstants.implementationType.sallenKey && filter.name === FilterConstants.filterType.lowPass) {
        const algorithm = preferredAlgorithm[`${name}|${filter.name}`];
        return algorithm;
      } else {
        return filter.name.toLowerCase();
      }
    } else {
      if (name === FilterConstants.implementationType.sallenKey && filter.name === FilterConstants.filterType.lowPass) {
        return FilterConstants.model.inputs.components.defaultAlgorithm['sallenKey|lowPass'];
      } else {
        return filter.name.toLowerCase();
      }
    }
  }

  getStepValues(idealStep, circuit, timeAxis) {
    return this.instance.getStepValues(idealStep, circuit, timeAxis);
  }

  createCircuit(stageFp, gain, stageQ, optimization, initialCapacitorValue) {
    return this.instance.createCircuit(stageFp, gain, stageQ, optimization, initialCapacitorValue);
  }

  createBigHugeCircuitGroup(circuit, toleranceInput) {
    return this.instance.createBigHugeCircuitGroup(circuit, toleranceInput);
  }

  getInterestingCircuits(commercialCircuit, toleranceInput) {
    return this.instance.getInterestingCircuits(commercialCircuit, toleranceInput);
  }
}
